import type { CorrectArea } from '@core-api/editor/types/response';
import type { Question } from '../../../legacy-series-types';

export const correctAreaToQuestionCorrectArea = (
  correctArea: CorrectArea | null,
): Question['correct_area'] => {
  if (correctArea) {
    const { top, left, right, bottom } = correctArea;
    const isReset = top === 0 && left === 0 && right === 1 && bottom === 1;
    return isReset
      ? null
      : [
          [left, top],
          [left, bottom],
          [right, bottom],
          [right, top],
          [left, top],
        ];
  }

  return null;
};
